module.exports = __webpack_public_path__ + "static/Kwera_Credits_Anna-aee993d09297d6cff658b63c1b372607.png";